import { render } from "./JsonText.vue?vue&type=template&id=a3501d1a&scoped=true&ts=true"
import script from "./JsonText.vue?vue&type=script&lang=ts"
export * from "./JsonText.vue?vue&type=script&lang=ts"

import "./JsonText.vue?vue&type=style&index=0&id=a3501d1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3501d1a"]])

export default __exports__